// English components translations
import currencyDescription from "./currencyDescription.js";
import aiAssessment from "./aiAssessment.js";
import homefooter from "./homefooter.js";
import surveyDialog from "./surveyDialog.js";
import surveymask from "./surveymask.js";
import weixinmask from "./weixinmask.js";
import uplodebalance from "./uplodebalance.js";
import trialmask from "./trialmask.js";
import topsearch from "./topsearch.js";
import togeneralseach from "./togeneralseach.js";
import temporarycanvassave from "./temporarycanvassave.js";
import screen from "./screen.js";
import savedialog from "./savedialog.js";
import savecanvasdialog from "./savecanvasdialog.js";
import operationhistory from "./operationhistory.js";
import leftcomponts from "./leftcomponts.js";
import editpassword from "./editpassword.js";
import advancedmask from "./advancedmask.js";
import bottomclick from "./bottomclick.js";

export default {
  currencyDescription,
  aiAssessment,
  homefooter,
  surveyDialog,
  surveymask,
  weixinmask,
  uplodebalance,
  trialmask,
  topsearch,
  togeneralseach,
  temporarycanvassave,
  screen,
  savedialog,
  savecanvasdialog,
  operationhistory,
  leftcomponts,
  editpassword,
  advancedmask,
  bottomclick,
};
